import { useSelector } from 'react-redux';
import { useCallback } from 'react';
import { RootState } from '../../../../../shared/state/root-reducer';
import { Vob } from '@finpay/estimation-types';
import { generateVobDisplayText } from '../utils/vob-utils';

interface Facility {
    facilityId: number;
    facilityName: string;
}

interface UseVobDataOptions {
    facilities?: Facility[];
    includeReduxVobs?: boolean;
}

export const useVobData = (options: UseVobDataOptions = {}) => {
    const { facilities = [], includeReduxVobs = false } = options;
    
    const selectedPatient = useSelector((state: RootState) => state.patientContext.selectedPatient);
    const vobSources = useSelector((state: RootState) => state.metaData.vobSource) || [];
    const reduxVobs = useSelector((state: RootState) => state.vobContext.patientVobList);
    const vobsLoading = useSelector((state: RootState) => state.vobContext.isLoading?.patientVobList);

    const getVobDisplayText = useCallback((vob: Vob): string => {
        return generateVobDisplayText(vob, selectedPatient, vobSources, facilities);
    }, [selectedPatient, vobSources, facilities]);

    return {
        selectedPatient,
        vobSources,
        getVobDisplayText,
        ...(includeReduxVobs && {
            vobs: reduxVobs || [],
            vobsLoading: vobsLoading || false
        })
    };
}; 